export default __webpack_public_path__ + "e768db77bdaea55c051bb8ce6fbe57ac.png";